export function convertToIST(dateString) {
    // Parse the date string into a Date object (in UTC)
    const dateUTC = new Date(dateString);
  
    // Format the date to "28 Jan, 2025"
    const formattedDate = dateUTC.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  
    // Format the time to "7:20 AM"
    const formattedTime = dateUTC.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  
    return { date: formattedDate, time: formattedTime };
  }